import React, {useState,useMemo,useCallback} from "react";
import {CardElement,useStripe,useElements} from "@stripe/react-stripe-js";
import {Form,Button,Alert} from "react-bootstrap";

const CardPaymentForm = ({onSuccess,darkMode}) => {
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const cardElementOptions = useMemo(
    () => ({
      style: {
        base: {
          color: darkMode
            ? "#e0e0e0cc"
            : "#000000",

          fontSize: "16px",

          fontFamily:
            '"Helvetica Neue", Helvetica, sans-serif',

          fontSmoothing: "antialiased",

          "::placeholder": {
            color: darkMode
              ? "#999"
              : "#666",
          },
        },

        invalid: {
          color: "#dc3545",
          iconColor: "#dc3545",
        },
      },
    }),
    [darkMode]
  );

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      setErrorMessage("");

      if (!stripe || !elements || loading) {
        return;
      }

      setLoading(true);

      try {
        const cardElement =
          elements.getElement(CardElement);

        if (!cardElement) {
          setErrorMessage(
            "Card element not found."
          );

          return;
        }

        const { error, paymentMethod } =
          await stripe.createPaymentMethod({
            type: "card",
            card: cardElement,
          });

        if (error) {
          setErrorMessage(
            error.message ||
              "Payment method creation failed."
          );

          return;
        }

        if (paymentMethod?.id) {
          await onSuccess(paymentMethod.id);
        }
      } catch (error) {
        console.error(
          "Card Payment Error:",
          error
        );

        setErrorMessage(
          "Something went wrong. Please try again."
        );
      } finally {
        setLoading(false);
      }
    },
    [stripe, elements, loading, onSuccess]
  );

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>
          Enter Card Details
        </Form.Label>

        <div
          style={{
            border: `1px solid ${
              darkMode
                ? "#444"
                : "#ced4da"
            }`,
            borderRadius: "8px",
            padding: "14px",
            backgroundColor: darkMode
              ? "#1e1e1e"
              : "#ffffff",
            transition:
              "all 0.2s ease-in-out",
          }}
        >
          <CardElement
            options={cardElementOptions}
          />
        </div>
      </Form.Group>

      {!!errorMessage && (
        <Alert variant="danger">
          {errorMessage}
        </Alert>
      )}

      <div className="d-flex justify-content-end align-items-center mt-3">
        <Button
          type="submit"
          variant="primary"
          disabled={
            loading ||
            !stripe ||
            !elements
          }
          className="m-3 start_subscription_trigger"
        >
          {loading
            ? "Processing..."
            : "Start Subscription"}
        </Button>
      </div>
    </Form>
  );
};

export default React.memo(CardPaymentForm);